import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { convertDateTime, formatDateTime } from "helpers/utils";
import {
  useActiveUserProfile,
  useInactiveUserProfile,
  useListDepartment,
  useListEmailDomainUserProfile,
  useListRoleUserProfile,
  useListUserProfile,
  useListUserType,
} from "hooks";
import React, { useEffect, useMemo, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListUserProfileColumn } from "store/actions";
import DetailUserProfile from "./DetailUserProfile";
import {
  getInitUserProfileParams,
  userProfileModeList,
  userProfileRecordStatus,
  userProfileRecordStatusMode,
  userProfileRole,
} from "./utils";

const ListUserProfile = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["userProfile"]);

  const {
    list: { columnsVisible: userProfileColumnsVisible },
  } = useSelector(state => state.userProfile);

  /* ================================== START INIT STATE ==================================== */

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const [userProfileData, setUserProfileData] = useState(null);
  const [inactiveUserProfileModal, setInactiveUserProfileModal] =
    useState(false);
  const [activeUserProfileModal, setActiveUserProfileModal] = useState(false);
  const [userProfileParams, setUserProfileParams] = useState(
    getInitUserProfileParams
  );
  const [filterRoleSelected, setFilterRoleSelected] = useState(null);

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  // USER ROLE LIST

  const {
    isLoading: isLoadingListRoleUserProfile,
    data: userProfileRoleList,
    refetch: listRoleUserProfile,
  } = useListRoleUserProfile({ params: {} });

  // EMAIL DOMAIN LIST

  const {
    isLoading: isLoadingListEmailDomainUserProfile,
    data: userProfileEmailDomainList,
    refetch: listEmailDomainUserProfile,
  } = useListEmailDomainUserProfile({ params: {} });

  // USER LIST

  const {
    isLoading,
    data: userProfileList,
    refetch: listUserProfile,
  } = useListUserProfile({ params: userProfileParams });

  const { data: listUserType, refetch: fetchListUserType } = useListUserType();
  const { data: listDepartment, refetch: fetchListDepartment } =
    useListDepartment({
      params: {
        "filter[record_status]": "O",
        page: -1,
      },
    });

  // ACTIVE

  const handleActiveUserProfile = () => {
    listUserProfile();
  };

  const { mutate: activeUserProfile } = useActiveUserProfile(
    handleActiveUserProfile,
    handleActiveUserProfile
  );

  // INACTIVE

  const handleInactiveUserProfile = () => {
    listUserProfile();
  };

  const { mutate: inactiveUserProfile } = useInactiveUserProfile(
    handleInactiveUserProfile,
    handleInactiveUserProfile
  );

  useEffect(() => {
    if (userProfileParams && userProfileParams.run) {
      listUserProfile();
    }
  }, [userProfileParams]);

  useEffect(() => {
    setUserProfileParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));

    listRoleUserProfile();
    listEmailDomainUserProfile();
    fetchListUserType();
    fetchListDepartment();

    initColumn();
  }, [t]);

  useEffect(() => {
    if (userProfileList) {
      initColumn();
    }
  }, [userProfileList]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    if (
      userProfileColumnsVisible &&
      Object.keys(userProfileColumnsVisible).length > 0
    ) {
      initColumns.forEach(item => {
        if (userProfileColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !userProfileColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListUserProfileColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "user_profile") {
          options = userProfileRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "user_profile") {
          options = userProfileRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    const columnFilterClone = {
      ...columnFilter,
      "filter[department_id]": undefined,
      department_id: columnFilter["filter[department_id]"],
    };
    setUserProfileParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : userProfileParams.sort,
      columnFilter: columnFilterClone || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onSearchAllHandle = value => {
    setUserProfileParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  // INACTIVE

  const toggleInactiveUserProfileModal = () => {
    setInactiveUserProfileModal(!inactiveUserProfileModal);
  };

  const onClickInactiveUserProfile = (row, index) => {
    setUserProfileData(row);
    toggleInactiveUserProfileModal();
  };

  const inactiveUserProfileHandler = () => {
    inactiveUserProfile({
      userProfileId: userProfileData?.id,
      data: {
        record_status: userProfileRecordStatusMode.INACTIVE,
        display_name: userProfileData?.display_name,
        roles: userProfileData?.ext_value?.roles || [],
        email: userProfileData?.email,
        phone: userProfileData?.phone,
      },
    });
    toggleInactiveUserProfileModal();
  };

  // ACTIVE

  const toggleActiveUserProfileModal = () => {
    setActiveUserProfileModal(!activeUserProfileModal);
  };

  const onClickActiveUserProfile = (row, index) => {
    setUserProfileData(row);
    toggleActiveUserProfileModal();
  };

  const activeUserProfileHandler = () => {
    activeUserProfile({
      userProfileId: userProfileData?.id,
      data: {
        record_status: userProfileRecordStatusMode.ACTIVE,
        display_name: userProfileData?.display_name,
        roles: userProfileData?.ext_value?.roles || [],
        email: userProfileData?.email,
        phone: userProfileData?.phone,
      },
    });
    toggleActiveUserProfileModal();
  };

  // DETAIL

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case userProfileModeList.EDIT_USER_PROFILE_DETAIL:
        listUserProfile();
        break;
      default:
        break;
    }
  };

  const clickEditUserProfileHandler = (row, index) => {
    setDataDetail({ userProfileId: row.id });
    setMode(userProfileModeList.EDIT_USER_PROFILE_DETAIL);
    toggleDetailModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ userProfileId: row.id });
      setMode(userProfileModeList.VIEW_USER_PROFILE_DETAIL);
      toggleDetailModal();
    },
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listRowAction = [
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.user_profile"),
      onClick: clickEditUserProfileHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.user_profile"),
      conditionVisible: {
        record_status: [userProfileRecordStatusMode.ACTIVE],
      },
      onClick: onClickInactiveUserProfile,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.user_profile"),
      conditionVisible: {
        record_status: [userProfileRecordStatusMode.INACTIVE],
      },
      onClick: onClickActiveUserProfile,
    },
  ];

  const listMultipleRowAction = [];

  const currentDepartment = useMemo(() => {
    if (userProfileParams.columnFilter["department_id"]) {
      const findItem = listDepartment?.items?.find(
        item => item.id === userProfileParams.columnFilter["department_id"]
      );
      if (findItem) {
        return {
          label: findItem.name,
          value: findItem.id,
        };
      } else {
        return undefined;
      }
    }
    return undefined;
  }, [userProfileParams.columnFilter["department_id"], listDepartment]);

  const initColumns = [
    {
      dataField: "username",
      text: t("table.username"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.username"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "display_name",
      text: t("table.display_name"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.display_name"),
        }),
      }),
      sort: true,
      allowExport: true,
      style: {
        minWidth: "200px",
      },
    },
    {
      dataField: "user_type",
      text: t("table.user_role"),
      sort: false,
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "200px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select")}
              options={
                listUserType?.map(item => ({
                  label: item.name,
                  value: item.code,
                })) || []
              }
              classNamePrefix="select2-selection"
              value={filterRoleSelected}
              onChange={data => {
                onFilter({ data: data });
                setFilterRoleSelected(data);
              }}
            />
          </div>
        );
      },
      formatter: (cell, row, rowIndex, extraData) => {
        const roleList = row.ext_value?.roles;
        if (
          roleList &&
          roleList.length > 0 &&
          userProfileRoleList &&
          userProfileRoleList.items &&
          userProfileRoleList.items.length > 0
        ) {
          const nameRoles = [];

          roleList.forEach(role => {
            if (role === "ROLE_MSPLOGISTIC_GS_DEFAULT") {
              return;
            }

            const resultFind = userProfileRoleList.items.find(
              item => item.code === role
            );

            if (resultFind) {
              nameRoles.push(resultFind.name);
            }
          });

          return nameRoles.length > 0 ? nameRoles.join(" | ") : "";
        } else {
          return <></>;
        }
      },
      allowExport: true,
    },
    {
      dataField: "department_id",
      text: t("table.department_name"),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),

      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "200px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select")}
              options={
                listDepartment?.items?.map(item => ({
                  label: item.name,
                  value: item.id,
                })) || []
              }
              value={currentDepartment}
              classNamePrefix="select2-selection"
              onChange={data => {
                onFilter({ data: data });
              }}
            />
          </div>
        );
      },
      formatter: (cell, row, rowIndex, extraData) => row?.department_name,
    },
    {
      dataField: "record_status",
      text: t("table.record_status.user_profile.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.user_profile.name"),
        }),
        options: selectOptionsTable(undefined, "record_status", "user_profile"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && userProfileRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "user_profile");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY_hh_mm_ss);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={userProfileParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY_hh_mm_ss);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={userProfileParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.checker_id"),
        }),
      }),
      allowExport: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${userProfileList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("common:general_management") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail User Profile Modal */}
              <DetailUserProfile
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
                userProfileRoleList={userProfileRoleList}
                userProfileEmailDomainList={userProfileEmailDomainList}
              />
              {/* Delete User Profile Modal */}
              <ConfirmModal
                isOpen={inactiveUserProfileModal}
                titleHeader={t(
                  "form.submit.delete.user_profile.confirm.header"
                )}
                titleBody={t("form.submit.delete.user_profile.confirm.body")}
                onConfirm={inactiveUserProfileHandler}
                textBtnConfirm={t(
                  "form.submit.delete.user_profile.confirm.agree"
                )}
                textBtnCancel={t(
                  "form.submit.delete.user_profile.confirm.cancel"
                )}
                toggle={toggleInactiveUserProfileModal}
              />
              {/* Active User Profile Modal */}
              <ConfirmModal
                isOpen={activeUserProfileModal}
                titleHeader={t(
                  "form.submit.active.user_profile.confirm.header"
                )}
                titleBody={t("form.submit.active.user_profile.confirm.body")}
                onConfirm={activeUserProfileHandler}
                textBtnConfirm={t(
                  "form.submit.active.user_profile.confirm.agree"
                )}
                textBtnCancel={t(
                  "form.submit.active.user_profile.confirm.cancel"
                )}
                toggle={toggleActiveUserProfileModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    keyField="id"
                    data={userProfileList?.items || []}
                    columns={columnsTable}
                    page={userProfileParams.page}
                    sizePerPage={userProfileParams.sizePerPage}
                    totalSize={userProfileList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <Link
                      to="/user-profile/create"
                      className="btn btn-primary btn-label"
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </Link>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListUserProfile;
